export default [
  {
    path: "sys/org-user-list",
    name: "OrgUserList",
    component: () => import('./org-user/OrgUserList.vue')
  },
  {
    path: "sys/child-org-list",
    name: "ChildOrgList",
    component: () => import('./org/ChildOrgList.vue')
  },
  {
    path: "sys/bj-list",
    name: "BjList",
    component: () => import('./org/BjList.vue')
  },
  {
    path: "sys/org-list",
    name: "OrgList",
    component: () => import('./org/OrgList.vue')
  },
  {
    path: "sys/student-list",
    name: "StudentUserList",
    component: () => import('./org-user/StudentUserList.vue')
  },
  {
    path: "sys/syslog-list",
    name: "SysLogList",
    component: () => import('./log/SysLogList.vue')

  },
  {
    path: "sys/sys-about",
    name: "SysAbout",
    component: () => import('./about/SysAbout.vue')
  },
 
  {
    path: "sys/sys-setting",
    name: "SysSettingList",
    component: () => import('./setting/SysSettingList.vue')
  },
  {
    path: "sys/org-fdy",
    name: "BjFdyXqList",
    component: () => import('./org/BjFdyXqList.vue')
  },
  {
    path: "sys/child-org-fzr-list",
    name: "ChildOrgfzrXqList",
    component: () => import('./org/ChildOrgfzrXqList.vue')
  },
  {
    path: "sys/jsqx-list",
    name: "SysJsqxList",
    component: () => import('./jsqx/SysJsqxList.vue')
  },
  {
    path: "sys/set-jsqx-form",
    name: "SetJsqxForm",
    component: () => import('./jsqx/SetJsqxForm.vue')
  },
  {
    path: "sys/sys-jiangshi-list",
    name: "JiangshiList",
    component: () => import('./jiangshi/JiangshiList.vue')
  },
  {
    path: "sys/order-list",
    name: "OrderList",
    component: () => import('./order/OrderList.vue')
  },
  {
    path: "sys/appversion-list",
    name: "appversionList",
    component: () => import('./upgrade/appversionList.vue')
  },
  {
    path: "sys/client-list",
    name: "ClientList",
    component: () => import('./client/client-all.vue')
  },
  {
    path: "sys/student-mg-list",
    name: "StudentMgList",
    component: () => import('./student/student-mg.vue')
  },
  {
    path: "sys/client-list/change",
    name: "ClientAllChange",
    component: () => import('./client/client-all-change.vue')
  },

  {
    path: "sys/student-user/confirm",
    name: "StudentUserConfirmList",
    component: () => import('./dissent/dissent-user-confirm.vue')
  },

  {
    path: "sys/student-fee-list",
    name: "StudentFeeList",
    component: () => import('./cost/StudentFeeList.vue')
  },
];
